import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';
import {
  getDefaultCreditCard,
  getNonDefaultCreditCards
} from 'redux/customerCreditCards/reducers';

const CreditCards = (props) => {
  const { defaultCreditCard, nonDefaultCreditCards } = props;
  if (!nonDefaultCreditCards) {
    return null;
  }
  let creditCardCount = 0;
  if (defaultCreditCard) {
    creditCardCount += 1;
  }
  const totalCreditCards = nonDefaultCreditCards.length + creditCardCount;
  const maxRows = 2;
  const moreNumber =
    totalCreditCards > maxRows ? totalCreditCards - maxRows : null;
  const displayArray = nonDefaultCreditCards.slice(
    0,
    maxRows - creditCardCount
  );
  return (
    <div className="c7-account-tile">
      <h3>Credit Card On File</h3>
      {totalCreditCards === 0 && (
        <>
          You have no saved credit cards on file.
          <br />
          <br />
          <Link to="/profile/credit-card/add" className="c7-button-small">
            Add first credit card
          </Link>
        </>
      )}

      {defaultCreditCard && (
        <div className="c7-account-tile__section">
          <CreditCardDisplay creditCard={defaultCreditCard} />
          <br />
          <em>(Default)</em>
          <Link
            to={`/profile/credit-card/${defaultCreditCard.id}`}
            className="c7-button-alt-small"
          >
            Edit
          </Link>
        </div>
      )}

      {displayArray.map((creditCard) => (
        <div key={creditCard.id} className="c7-account-tile__section">
          <CreditCardDisplay creditCard={creditCard} />
          <Link
            to={`/profile/credit-card/${creditCard.id}`}
            className="c7-button-alt-small"
          >
            Edit
          </Link>
        </div>
      ))}
      <br />
      {renderMore(moreNumber)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  defaultCreditCard: getDefaultCreditCard(state.customerCreditCard),
  nonDefaultCreditCards: getNonDefaultCreditCards(state.customerCreditCard)
});

export default connect(mapStateToProps)(CreditCards);

const renderMore = (moreNumber) => {
  if (!moreNumber) {
    return null;
  }
  return (
    <Link to="/profile/credit-card" className="c7-button-small">
      View {moreNumber} more
    </Link>
  );
};
